import React, { Component } from 'react';
import * as Constants from './api/constants'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import BlacklistList from './blacklist.components/BlacklistList';
import { MainContext } from '../context/MainContext'
import { UserContext } from '../context/UserContext'
import AdminSettingsSVLink from './adminSettings.components/AdminSettingsSVLink'

export default class Blacklist extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      blacklistList: [],
      spinner: false
    };
  }

  getBlacklistList = (macAddress = '') => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      searchMacAddress: macAddress
    });

    fetch(Constants.baseURL + Constants.apiGetSpaBlacklist + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          this.props.history.push('/');
        }
        return response.json()
      })
      .then(data => {
        this.setState({
          blacklistList: data.blacklist,
          spinner: false
        });
      })
      .catch(error => { console.log('request failed', error); });
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      blacklistList: [],
      spinner: false
    })

    this.getBlacklistList();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    return (<Container maxWidth="900px" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        {/* Blacklist */}
        <Grid item xs={12} md={12} lg={12}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              bgcolor: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)',
              height: 713,
            }}
          >
            <UserContext.Provider value={this.props} >
              <MainContext.Provider value={this.state.blacklistList} >
                <BlacklistList getBlacklistList={this.getBlacklistList} />
              </MainContext.Provider>
            </UserContext.Provider>
          </Paper>
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          <Paper sx={{
            p: 2, bgcolor: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)', borderRadius: 4
          }}>
            <AdminSettingsSVLink />
          </Paper>
        </Grid>
      </Grid>
      <Copyright sx={{ pt: 4 }} />
    </Container>);
  }
}